import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/** Simple scroll-reveal wrapper. */
export const Reveal = ({ children, delay = 0, y = 24, className = "", once = true, as = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

/** Masked line-by-line reveal for hero headline text. */
export const LineReveal = ({ children, delay = 0, className = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) return <span className={className}>{children}</span>;
  return (
    <span className={`word-reveal ${className}`}>
      <motion.span
        style={{ display: "inline-block" }}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};

/** Staggered word reveal (for tagline). */
export const WordsReveal = ({ text, baseDelay = 0.15, className = "" }) => {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <LineReveal key={i} delay={baseDelay + i * 0.045}>
          {w}&nbsp;
        </LineReveal>
      ))}
    </span>
  );
};
